<template>
  <div>
    <SidebarSearch
      @submit="submitForm"
      @clear="clearForm"
    >
      <SearchCollapse
        :expanded="true"
        title="Geral"
      >
        <NxSelectFuncionario
          :multiple="false"
          :variable="employeeTypes.GERENTEUSER"
          @update:value="handleSelectUpdate('usuarioId', $event)"
        />
        <NxInputDateRange
          label="Período"
          @update:InitialValue="handleInputDateUpdate('dataInicial', $event)"
          @update:FinalValue="handleInputDateUpdate('dataFinal', $event)"
        />
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import employeeTypes from '@/enums/enumEmployeeTypes.js'

import { NxInputDateRange } from '@/components/nexum/components/custom-inputs/index.js'
import {
  NxSelectFuncionario,
  NxSelectKMPeriodo
} from '@/components/nexum/components/custom-selects/index.js'

export default {
  name: 'SidebarVisitaDeslocamento',
  components: {
    SidebarSearch,
    SearchCollapse,
    NxSelectKMPeriodo,
    NxSelectFuncionario,
    NxInputDateRange
  },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        usuarioId: null,
        dataInicial: null,
        dataFinal: null
      },
      employeeTypes: employeeTypes
    }
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If input comes as a string or a number
      if (
        typeof selectedValue === 'string' ||
        typeof selectedValue === 'number'
      ) {
        this.form[fieldName] = selectedValue
        return
      }
      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      // If to clear single select and update both types
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue)
          ? selectedValue.map((v) => v.value)
          : selectedValue.value
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        let parts = inputedValue.split('-')
        let reversed = parts.reverse()
        let newDate = reversed.join('/')
        this.form[fieldName] = newDate
      } else {
        this.clearField(fieldName)
      }
    },
    handleRadioButtonUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        this.form[fieldName] = inputedValue
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/visitas/reports/deslocamento/search/SidebarVisitaDeslocamento.vue